/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/display-name */
import React, { FC, useState } from 'react';
import { Dropdown, Menu, Row, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { MoreOutlined } from '@ant-design/icons';
import {
  ApolloQueryResult,
  MutationFunction,
  OperationVariables,
  useReactiveVar,
} from '@apollo/client';
import operations from 'apollo/operations';
import { User } from 'apollo/types';
import EditModal from 'components/modals/EditModal';
import styles from './AccountsTable.module.scss';

interface UsersTableProps {
  loading: boolean;
  data: User[];
  refetchUsers: (
    variables?: Partial<OperationVariables> | undefined,
  ) => Promise<
    ApolloQueryResult<{
      listUser: User[];
    }>
  >;
}

const UsersTable: FC<UsersTableProps> = (props: UsersTableProps) => {
  const { loading, data, refetchUsers } = props;
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editUser, setEditUser] = useState<User | null>(null);

  const actionColumn = (user: User) => (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            key="delete"
            onClick={() => {
              setEditModalVisible(true);
              setEditUser(user);
            }}
          >
            <span>Configurar</span>
          </Menu.Item>
        </Menu>
      }
      placement="bottomRight"
      arrow
    >
      <MoreOutlined style={{ fontSize: '24px' }} />
    </Dropdown>
  );

  // eslint-disable-next-line @typescript-eslint/require-await
  const handleEditUser = async (user: User) => {
    // eslint-disable-next-line no-console
    console.log({ user });
  };

  const columns: ColumnsType<User> = [
    {
      title: <h3>Nombre</h3>,
      render: (user: User) => <span className={styles.Span}>{user.name}</span>,
      sorter: (a: User, b: User) => {
        const firstUserName = a.name ? a.name : 'Usuario sin nombre';
        const secondUserName = b.name ? b.name : 'Usuario sin nombre';
        return firstUserName.localeCompare(secondUserName);
      },
    },
    {
      title: <h3>RUT</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.username}</span>
      ),
      sorter: (a: User, b: User) => {
        const firstUserRut = a.username ? a.username : 'Usuario sin mail';
        const secondUserRut = b.username ? b.username : 'Usuario sin mail';
        return firstUserRut.localeCompare(secondUserRut);
      },
    },
    {
      title: <h3>Usuario BCI</h3>,
      width: '10%',
      render: (user: User) => (
        <span className={styles.Span}>{user.bciUsername}</span>
      ),
    },
    {
      title: <h3>Dealer BCI</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.bciDealer}</span>
      ),
    },
    {
      title: <h3>Contraseña BCI</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.bciPassword}</span>
      ),
    },
    {
      title: <h3>Contraseña Zurich</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.zurichPassword}</span>
      ),
    },
    {
      title: <h3>Sucursal</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.dealer}</span>
      ),
    },
    {
      title: <h3>Rol</h3>,
      render: (user: User) => (
        <span className={styles.Span}>{user.role || 'Sin rol (usuario)'}</span>
      ),
    },
    {
      align: 'right',
      render: (user: User) => actionColumn(user),
    },
  ];

  return (
    <>
      <Row className={styles.TableContainer}>
        <EditModal
          visible={editModalVisible}
          handleOk={() => setEditModalVisible(false)}
          handleCancel={() => setEditModalVisible(false)}
          userData={editUser}
          refetchUsers={refetchUsers}
          // subject="invitación"
          // subjectGender="F"
          // additionalMessage="El correo de invitación ya fue enviado. De todas formas, el usuario no podrá crearse una cuenta."
        />
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          rowKey={(user: User) => user.username}
        />
      </Row>
    </>
  );
};

export default UsersTable;
